//
// Copyright (c) 2016 by Curalate, Inc.
//

/*global angular: false */

(function() {
    'use strict';

    var curalate = angular.module('curalate');

    // imageDimensions - Binds the image dimensions after the image is loaded via the img tag.
    //
    // Usage: <img src="..." image-dimensions="scope.dimensions" />
    //
    curalate.directive('imageDimensions', [function() {
        return {
            restrict: 'A',
            scope: {
                imageDimensions: "="
            },
            link: function(scope, elem) {
                elem.on('load', function() {
                    var self = this;
                    scope.$apply(function() {
                        scope.imageDimensions = {
                            width: self.width,
                            height: self.height,
                            naturalWidth: self.naturalWidth,
                            naturalHeight: self.naturalHeight
                        };
                    });
                });
            }
        };
    }]);
})();
